import { Letter } from 'state/letter/types'
import { useDeleteLetterRequest } from 'state/letter/hooks'

import { notifications } from 'constants/notifications'

import { useOpenModal } from 'modal'
import { newConfirmModal } from 'modals'
import { CellProps, Button } from 'components/ui'
import { useCallNotification } from 'notifications/hooks'
import { NotificationTypes } from 'notifications/service'

import { Wrapper, Title } from '../Style'

export function Delete({ row }: CellProps<Letter>) {
  const openModal = useOpenModal()
  const callNotification = useCallNotification()
  const { onDeleteLetter, isLoading } = useDeleteLetterRequest()

  const { id } = row.original

  const handleDelete = () => {
    openModal(newConfirmModal({ action: handleDeleteLetter }))
  }

  const handleDeleteLetter = async () => {
    try {
      await onDeleteLetter(id)
    } catch (err) {
      callNotification({ type: NotificationTypes.ERROR, message: notifications.errors.deleteLetter(err.message) })
    }
  }

  return (
    <Wrapper area='Delete'>
      <Title>Delete</Title>
      <Button type='outline' size='small' loadingText='' onClick={handleDelete} isLoading={isLoading}>
        Delete
      </Button>
    </Wrapper>
  )
}
